(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-patio-banner-slider"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-mp-slider]').forEach((slider) => {
    if (slider.dataset.initialized === 'true') return;
    slider.dataset.initialized = 'true';
    const slides = Array.from(slider.querySelectorAll('[data-mp-slide]'));
    const dots = Array.from(slider.querySelectorAll('[data-mp-dot]'));
    if (slides.length < 2) return;
    let current = 0;
    let timer;
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const show = (index) => {
      current = (index + slides.length) % slides.length;
      slides.forEach((slide, i) => { slide.classList.toggle('is-active', i === current); slide.setAttribute('aria-hidden', i === current ? 'false' : 'true'); });
      dots.forEach((dot, i) => { dot.classList.toggle('is-active', i === current); dot.setAttribute('aria-selected', i === current ? 'true' : 'false'); });
    };
    const stop = () => window.clearInterval(timer);
    const play = () => { stop(); if (!reducedMotion) timer = window.setInterval(() => show(current + 1), Number(slider.dataset.speed) || 6000); };
    slider.querySelector('[data-mp-prev]')?.addEventListener('click', () => { show(current - 1); play(); });
    slider.querySelector('[data-mp-next]')?.addEventListener('click', () => { show(current + 1); play(); });
    dots.forEach((dot) => dot.addEventListener('click', () => { show(Number(dot.dataset.mpDot)); play(); }));
    slider.addEventListener('mouseenter', stop);
    slider.addEventListener('mouseleave', play);
    slider.addEventListener('focusin', stop);
    slider.addEventListener('focusout', play);
    document.addEventListener('visibilitychange', () => document.hidden ? stop() : play());
    play();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-patio-builder"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-mp-builder]').forEach((builder) => {
    if (builder.dataset.initialized === 'true') return;
    builder.dataset.initialized = 'true';
    const options = Array.from(builder.querySelectorAll('[data-builder-option]'));
    const summaryItems = builder.querySelector('[data-summary-items]');
    const summaryEmpty = builder.querySelector('[data-summary-empty]');
    const count = builder.querySelector('[data-selection-count]');
    const planInput = builder.querySelector('[data-plan-input]');
    const itemLabel = count ? count.textContent.trim().replace(/^[0-9]+\s*/, '') : '';
    const selections = new Map();

    const keyFor = (button) => `${button.dataset.categoryLabel}::${button.dataset.optionLabel}`;

    const sync = () => {
      summaryItems.innerHTML = '';
      selections.forEach((selection, key) => {
        const item = document.createElement('div');
        item.className = 'mp-builder-summary__item';
        if (selection.image) {
          const media = document.createElement('span');
          media.className = 'mp-builder-summary__media';
          const image = document.createElement('img');
          image.src = selection.image;
          image.alt = '';
          image.loading = 'lazy';
          media.append(image);
          item.append(media);
        }
        const copy = document.createElement('div');
        copy.className = 'mp-builder-summary__copy';
        const category = document.createElement('small');
        category.textContent = selection.category;
        const title = document.createElement('strong');
        title.textContent = selection.review ? `${selection.option} · Professional review` : selection.option;
        const remove = document.createElement('button');
        remove.type = 'button';
        remove.setAttribute('aria-label', `Remove ${selection.option}`);
        remove.textContent = '×';
        remove.addEventListener('click', () => {
          selections.delete(key);
          selection.button.setAttribute('aria-pressed', 'false');
          sync();
        });
        copy.append(category, title);
        item.append(copy, remove);
        summaryItems.append(item);
      });
      summaryEmpty.hidden = selections.size > 0;
      count.textContent = `${selections.size} ${itemLabel}`;
      planInput.value = Array.from(selections.values()).map((selection) => `${selection.category}: ${selection.option}${selection.review ? ' (professional review required)' : ''}`).join(' | ');
    };

    options.forEach((button) => {
      button.addEventListener('click', async () => {
        const key = keyFor(button);
        const isSelected = button.getAttribute('aria-pressed') === 'true';
        if (button.dataset.variantId && !isSelected) {
          button.disabled = true;
          try {
            const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ items: [{ id: Number(button.dataset.variantId), quantity: 1 }] })
            });
            if (!response.ok) throw new Error('Unable to add this item to cart.');
            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          } catch (error) {
            window.alert(error.message);
            button.disabled = false;
            return;
          }
          button.disabled = false;
        }
        button.setAttribute('aria-pressed', isSelected ? 'false' : 'true');
        if (isSelected) {
          selections.delete(key);
        } else {
          selections.set(key, {
            category: button.dataset.categoryLabel,
            option: button.dataset.optionLabel,
            review: button.dataset.reviewRequired === 'true',
            image: button.querySelector('.mp-builder-card__image')?.currentSrc || button.querySelector('.mp-builder-card__image')?.src || '',
            button
          });
        }
        sync();
      });
    });

    builder.querySelectorAll('.mp-builder-step').forEach((step) => {
      const rail = step.querySelector('[data-builder-rail]');
      const amount = () => Math.max(rail.clientWidth * .82, 300);
      step.querySelector('[data-rail-prev]').addEventListener('click', () => rail.scrollBy({ left: -amount(), behavior: 'smooth' }));
      step.querySelector('[data-rail-next]').addEventListener('click', () => rail.scrollBy({ left: amount(), behavior: 'smooth' }));
    });

    builder.querySelectorAll('[data-category-filter]').forEach((filter) => {
      filter.addEventListener('click', () => {
        const category = filter.dataset.categoryFilter;
        builder.querySelectorAll('[data-category-filter]').forEach((item) => item.classList.toggle('is-active', item === filter));
        builder.querySelectorAll('.mp-builder-step').forEach((step) => {
          step.hidden = category !== 'all' && step.dataset.category !== category;
        });
      });
    });

    sync();
  });

  } catch(e) { console.error(e); }
})();
})();
